module.exports = __webpack_public_path__ + "static/media/ZPET.3b82636e.pdf";